module.exports = __webpack_public_path__ + "img/frl_logo_greyblue.146d34c5.png";